module.exports = __webpack_public_path__ + "media/application/images/svgs/grid-56af759881355d179b42c38c69c963dd.svg";